<template>
  <v-breadcrumbs
    v-if="breadcrumbs.length > 1"
    :items="breadcrumbs"
    divider=">"
    class="px-0 py-2"
    aria-label="Breadcrumb"
  >
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        :to="item.disabled ? undefined : item.to"
        :disabled="item.disabled"
        class="text-body-2"
      >
        <v-icon
          v-if="item.icon"
          :icon="item.icon"
          size="small"
          class="me-1"
        />
        {{ item.title }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { generateBreadcrumbs } from '@/utils/breadcrumb'

const route = useRoute()
const { t } = useI18n()

const breadcrumbs = computed(() => {
  return generateBreadcrumbs(route, t)
})
</script>

<style scoped>
.v-breadcrumbs {
  padding-top: 8px;
  padding-bottom: 8px;
}

.v-breadcrumbs-item--disabled {
  opacity: 1;
}
</style>